import React, { useEffect, useState } from "react";
import { format } from "utils/numberUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationComponent = ({
  count = "",
  limit = 10,
  currentPage = "",
  showCount = true,
  showPagination = true,
  setCurrentPage = null,
  onPageClick = () => { },
  onFirstPageClick = () => { },
  onLastPageClick = () => { },
  goNext = () => { },
  goPrevious = () => { }
}) => {
  const [totalPage, setTotalPages] = useState(0);

  useEffect(() => {
    setTotalPages(
      count < limit
        ? 1
        : count % limit === 0
          ? count / limit
          : Math.trunc(count / limit) + 1
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, limit]);

  const goToPage = (e, pageNo) => {
    e.preventDefault();
    if (setCurrentPage) {
      setCurrentPage(pageNo);
    } else {
      onPageClick(pageNo);
    }
  };

  const goToFirstPage = (e) => {
    e.preventDefault();
    onFirstPageClick(0);
    if (setCurrentPage) {
      setCurrentPage(0);
    } else {
      onFirstPageClick(0);
    }
  };

  const goToLastPage = (e) => {
    e.preventDefault();
    if (setCurrentPage) {
      setCurrentPage(totalPage - 1);
    } else {
      onLastPageClick(totalPage - 1);
    }
  };

  const goToNext = (e) => {
    e.preventDefault();
    if (setCurrentPage) {
      setCurrentPage(currentPage + 1);
    } else {
      goNext(currentPage + 1);
    }
  };

  const goToPrevious = (e) => {
    e.preventDefault();
    if (setCurrentPage) {
      setCurrentPage(currentPage - 1);
    } else {
      goPrevious(currentPage - 1);
    }
  };

  const PageNumber = () => {
    let page = [];
    for (let i = 1; i <= totalPage; i++) {
      page.push(
        <PaginationItem
          key={i}
          active={currentPage + 1 === i}
          style={{
            display:
              i < currentPage + 1 || i > currentPage + 5 ? "none" : "block"
          }}>
          <PaginationLink href="#/" onClick={(e) => goToPage(e, i - 1)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return page;
  };

  return (
    <div className="card-footer py-3 d-flex justify-content-between">
      {count > 0 && (
        <>
          {showPagination &&
            <Pagination className="pagination-second">
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink first href="#/" onClick={goToFirstPage}>
                  <FontAwesomeIcon icon={["fas", "angle-double-left"]} />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink previous href="#/" onClick={goToPrevious}>
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />
                </PaginationLink>
              </PaginationItem>
              <PageNumber />
              <PaginationItem disabled={currentPage + 1 === totalPage}>
                <PaginationLink next href="#/" onClick={goToNext}>
                  <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={currentPage + 1 === totalPage}>
                <PaginationLink last href="#/" onClick={goToLastPage}>
                  <FontAwesomeIcon icon={["fas", "angle-double-right"]} />
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          }
          {showCount &&
            <div className="d-flex align-items-center">
              <span>Total</span>
              <span className="mx-2 font-weight-bold">{format(count, 0)}</span>
              <span>{count < 2 ? "entry" : "entries"}</span>
            </div>
          }
        </>
      )}
    </div>
  );
};

export default PaginationComponent;
